var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preview.logo)?_c('div',{staticClass:"row login-preview text-center mb-5"},[_c('div',{staticClass:"col-2"}),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('div',[_c('img',{attrs:{"src":_vm.preview.logo}})]),_vm._v(" "),_c('h2',[_vm._v("Hej, "+_vm._s(_vm.preview.name))])]),_vm._v(" "),_c('div',{staticClass:"col-2"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620dde87","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Auth/Partials/LoginPreview.vue
// module id = 456
// module chunks = 0